export default "__VITE_ASSET__We9$jeRr__"